import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {TelcoService} from "../shared/services/telco.service";
import {Telco} from "../shared/services/telco";
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar, MatProgressBarModule } from '@angular/material';
import * as FileSaver from 'file-saver';
import { UtilsService } from '../shared/utils-service';

@Component({
	selector: 'app-telco',
	templateUrl: './telco.component.html',
	styleUrls: ['./telco.component.css']
})
export class TelcoComponent implements OnInit {
	private loader: boolean= false;
	showAdvanced: boolean;
	status : boolean;
	private mandStatus: boolean
	private mandStatusEdit: boolean
	model: any = {};
	search: any = {};
	modeledit: any = {};
	errorHandler: any = {};
	errorHandlerEdit: any = {};
	private sample: any = [];
	private telcoMember: any = [];
	private deleteUser: any = [];
	private users: any = [];
	private searchMember: any=[];
	private addData: any = [];
	private editData: any = [];
	private mandFields: any = [];
	private mandFieldsEdit: any = [];
	private url: string = this.utils.url+"//ddmfBlackList/myTelcoCredits?userId=";
	private addurl: string = this.utils.url+"/ddmfBlackList/addTelcoCredits";	
	private editurl: string = this.utils.url+"/ddmfBlackList/editTelcoCredits";
	private deleteurl: string = this.utils.url+"/ddmfBlackList/deleteTelcoCredits";
	private searchurl: string = this.utils.url+"/ddmfBlackList/searchTelcoCredits";
	private exporturl: string = this.utils.url+"/ddmfBlackList/exportTelcoCredits?userId=";
  displayedColumns: any = ['icNo', 'newIcNo', 'brNo', 'name', 'accountNo', 'dateOfBirth', 'entryDate', 'submitDate', 'remarks', 'actions'];
  dataSource: any = [];
  	curDate: Date = new Date();
	key: string = '';
	private dataJson: any = [];
	private loggedInUser: any = {};
	constructor(private telcoService: TelcoService, private http: Http, private router: Router,private matSnackBar: MatSnackBar, private utils: UtilsService) {
		this.loggedInUser = this.utils._checkSession({'page': 'telco'});
		this.showAdvanced = true;
		this.status = false;
		this.model.selectValue = 'ind';
		this.mandStatus = true;
   this.mandStatusEdit = true;
    this.displayedColumns = ['icNo', 'newIcNo', 'brNo', 'name', 'accountNo', 'dateOfBirth', 'entryDate', 'submitDate', 'remarks', 'actions'];
   // console.log(this.displayedColumns, 'displayedColumns');
    this.mandFields = ['selectValue','icNo','newicNo','brno','name','accountno','submitDate'];
    this.mandFieldsEdit = ['selectValueEdit','icNo','newIcNo','brNo','name','accountNo','submitDate'];
    
   
   // console.log(this.mandFields);
		 
	}

  @ViewChild(MatPaginator) paginator : MatPaginator;
  @ViewChild(MatSort) sort : MatSort;

	ngOnInit() {
		
	}
	
	getData() {
	var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
    return this.http.get(this.url+this.loggedInUser.userId,{ headers: headers });
  }
  
  export(){
  	/*this.http.get(this.exporturl+this.loggedInUser.userId).subscribe(data => {
  var mediaType = 'application/csv';
                    var blob = new Blob([data['_body']], {type: mediaType});
                    var filename = 'BlackList.csv';
                    FileSaver.saveAs(blob, filename);
},
		error => {
			// this.matSnackBar.open('Something went wrong!! Please try after some time.', 'Close', {
   //    			duration: 5000,
   //  		});
      this.utils.notify('Something went wrong!! Please try after some time.');
		});*/
		this.utils.exportCSV(this.dataJson, 'BlackList.csv', this.displayedColumns);
  } 
  
  
  resetData(){
    this.search= {};
    this.dataJson=[];
    this.users=[];
    this.paginator.pageIndex = 0;
  	
  }
  
  searchData($event, search){
  	this.paginator.pageIndex = 0;
  	this.searchMember=search;
    var headers = new Headers();
	headers.append('Content-Type', 'application/json');	
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
	let dateString = this.search.dateofbirth;
	let newDate = new Date(dateString);		
	
	if(this.search.icNo!=undefined || this.search.newicNo!=undefined || this.search.brno!=undefined || this.search.name!=undefined || this.search.accountno!=undefined)	{						
     if(this.search.icNo!="" || this.search.newicNo!="" || this.search.brno!="" || this.search.name!="" || this.search.accountno!=""){
        if(this.search.accountno){
        this.search.accountno = this.search.accountno.trim();
        } 
     this.loader=true;
   this.http.post(this.searchurl,JSON.stringify({
	      "icNo": this.search.icNo,
	      "newIcNo": this.search.newicNo,
	      "brNo": this.search.brno,
	      "name": this.search.name,
	      "accountNo": this.search.accountno,
	      "dateRangeFrom": this.utils.dateToDB(this.search.fromDate),
	      "dateRangeTo":this.utils.dateToDB(this.search.toDate),
	      "remark": this.search.remarks,
	      "userId": this.loggedInUser.userId
           }), { headers: headers }).subscribe(res => {
           		this.loader=false;
    			let json = JSON.parse(res['_body']);
   		 			if(json['mytelcoBlackListCustomerResponse'] == null){
    				var message=json['ddmfResponseStatus'].responseStatusMessage;
              this.utils.notify(message);
    					this.users = [];
    					this.paginator.length = 0;
    					this.dataJson = [];
    					this.dataJson.paginator = this.paginator;
						this.dataJson.sort = this.sort;
   					 } else {
					    this.dataJson = json['mytelcoBlackListCustomerResponse'];
					    //console.log(this.dataJson);
					    this.users = new MatTableDataSource(json['mytelcoBlackListCustomerResponse']);
					    this.users.paginator = this.paginator;
					    this.users.sort = this.sort;
					    }
				},
		error => {
		this.loader=false;
      this.utils.notify('Something went wrong!! Please try after some time.');
		}); 
  	}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
  	}
  	else{
  		this.utils.notify('Please enter the fields.');
  	}
 	 }
  
  deleteMember($event, deleteUser){
  	if(confirm("Are you sure you want to delete?")) {
  		this.deleteUser=deleteUser;
  	
  	
  		let dateString = this.deleteUser.dateOfBirth;
		let newDate = new Date(dateString);	
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
  	this.loader=true;
  	  this.http.post(this.deleteurl, JSON.stringify({"blackListId":this.deleteUser.blackListId,
  	  "icNo":this.deleteUser.icNo,
  	  "newIcNo":this.deleteUser.newIcNo,
  	  "brNo":this.deleteUser.brNo,
  	  "name":this.deleteUser.name,
  	  "accountNo":this.deleteUser.accountNo,
  	  "dateOfBirth":this.utils.dateToDB(this.deleteUser.dateOfBirth),
  	  "remark":this.deleteUser.remarks,
  	  "userId":this.loggedInUser.userId
  	  }), { headers: headers } ).subscribe(res => {
  	  this.loader=false;
	    this.editData = res;
	    this.editData = res['_body'];
	    this.editData = JSON.parse(this.editData);
	    var message = this.editData.ddmfResponseStatus.responseStatusMessage;
	    this.searchData($event, this.search);
      this.utils.notify(message);
  	},
		error => {
		this.loader=false;
      this.utils.notify('Something went wrong!! Please try after some time.');
		});
  	
  	}
  }
  
  editUser($event, telcoMember){
  	this.telcoMember=telcoMember;
  	if(this.telcoMember.brNo != ''){
  	this.telcoMember.selectValueEdit ='cbo';
  	} else{
  	this.telcoMember.selectValueEdit ='ind';
  	}
  	this.mandatoryCheckEdit(this.telcoMember);
  }
  
addMyTelcoCredit(){ 
	let errorFlag = false;
	for(let e in this.errorHandler){
		//console.log(e, this.errorHandler[e], 'eeeeee')
		if (this.errorHandler[e] && this.mandFields.length ==7 ) {
			errorFlag = true;
			this.utils.notify('Please enter value for all mandatory fields ');
		}
	}
	if (!errorFlag) {
	if(this.model.selectValue == 'cbo'){
	this.model.icNo="";
	this.model.newicNo="";
	} else {
	this.model.brno="";
	}
	
	//console.log(this.model);
		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
	
		let dateString = this.model.dateofbirth;
		let newDate = new Date(dateString);									
	     this.loader=true;
	   this.http.post(this.addurl,JSON.stringify({
			"icNo": this._checkNull(this.model.icNo),
			"newIcNo": this._checkNull(this.model.newicNo),
			"brNo": this._checkNull(this.model.brno),
			"name": this._checkNull(this.model.name),
			"accountNo": this._checkNull(this.model.accountno),
			"dateOfBirth": this.utils.dateToDB(this.model.dateofbirth),
			"remark": this._checkNull(this.model.remarks),
			"submitDate":this.utils.dateToDB(this.model.submitDate),
			"userId": this._checkNull(this.loggedInUser.userId)
	    }), { headers: headers }).subscribe(res => {
	    this.loader=false;
	    	let json = JSON.parse(res['_body']);
			    this.dataJson = json['mytelcoBlackListCustomerResponse'];
			    this.users = new MatTableDataSource(json['mytelcoBlackListCustomerResponse']);
			    this.users.paginator = this.paginator;
			    this.users.sort = this.sort;
		    var message = json.ddmfResponseStatus.responseStatusMessage;
		    
	      this.utils.notify(message);
		},
		error => {
		this.loader=false;
			this.utils.notify('Something went wrong!! Please try after some time.');
		});
		
		this.model = {};
	}
	
}
  
  
	editMyTelcoCredit(){
	  let errorFlagEdit = false;
	   	for(let e in this.errorHandlerEdit){
	   		//console.log(e, this.errorHandlerEdit[e], 'eeeeee')
	   		if (this.errorHandlerEdit[e] && this.mandFieldsEdit.length ==6 ) {
	   			errorFlagEdit = true;
	   			this.utils.notify('Please enter value for all mandatory fields ');
	   		}
	   	}
	   	if (!errorFlagEdit) {
	   		if(this.telcoMember.selectValueEdit == 'cbo'){
	   		this.telcoMember.icNo ="";
	   		this.telcoMember.newIcNo="";
	   		} else {
	   		this.telcoMember.brNo="";
	   		
	   		}
	  		var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('userId', this.loggedInUser.userId);
	headers.append('token', this.loggedInUser.token);
	  		let dateString = this.telcoMember.dateOfBirth;
			let newDate = new Date(dateString);	
	  		this.loader=true;
	  	  this.http.post(this.editurl,JSON.stringify({"blackListId":this._checkNull(this.telcoMember.blackListId),
	  	  "icNo":this._checkNull(this.telcoMember.icNo),
	  	  "newIcNo":this._checkNull(this.telcoMember.newIcNo),
	  	  "brNo":this._checkNull(this.telcoMember.brNo),
	  	  "name":this._checkNull(this.telcoMember.name),
	  	  "accountNo":this._checkNull(this.telcoMember.accountNo),
	  	  "dateOfBirth":this.utils.dateToDB(this.telcoMember.dateOfBirth),
	  	  "remark":this._checkNull(this.telcoMember.remarks),
	  	  "submitDate":this.utils.dateToDB(this.telcoMember.submitDate),
	  	  "userId":this._checkNull(this.loggedInUser.userId)
	  	  }), { headers: headers }).subscribe(res => {
	  	  this.loader=false;
			    this.editData = res['_body'];
			    this.editData = JSON.parse(this.editData);
			    var message = this.editData.ddmfResponseStatus.responseStatusMessage;
			    
			      this.utils.notify(message);
			},
			error => {
			this.loader=false;
	      		this.utils.notify('Something went wrong!! Please try after some time.');
			});
	  	
	  	}
	}
  goToURL(url){
		this.router.navigateByUrl(url);
		}
		_checkNull(v) {
		return (!v || v === null) ? '' : v;
	}
	mandatoryCheck(model) {
		//console.log(model);
		 this.mandFields = ['selectValue','icNo','newicNo','brno','name','accountno','submitDate'];
		 let count = 0;
		 if(this.model.selectValue == 'ind'){
		//console.log(this.mandFields,'mandfields');
		this.mandFields.splice(3,1);
		//console.log(this.mandFields,'mandfields');
		 }
		 else{
		//console.log(this.mandFields,'mandfields');
		this.mandFields.splice(1,2);
		//console.log(this.mandFields,'mandfields');
		 }
		 if(this.model.icNo =="" || this.model.icNo ==undefined){ 
		 	this.mandFields.splice(1,1);
		 	this.errorHandler['newicNo'] = true;
		 	}
		if(this.model.newicNo =="" || this.model.newicNo ==undefined){
		this.mandFields.splice(2,1);
		this.errorHandler['icNo'] = true;
		
		}
		//console.log(this.mandFields,'mandfields');
		for(let i =0; i<this.mandFields.length; i++){
			let item = this.model[this.mandFields[i]];
			//console.log(this.mandFields[i],' ', item);
			if(item ==undefined || item ==""){
				this.errorHandler[this.mandFields[i]] = true;
				count++;
			} else {
				this.errorHandler[this.mandFields[i]] = false;
			}
			//console.log(this.errorHandler);
			//this.errorHandler[item] = !this.model[item];
			//console.log(this.errorHandler[item],'result');
		}
		//console.log(this.mandFields,'mandfields');
		if(count == 0){
		this.mandStatus = false;
		} else {
		this.mandStatus = true;
		}
	}
	mandatoryCheckEdit(telcoMember) {
	let countEdit = 0;
		//console.log(telcoMember);
		 this.mandFieldsEdit = ['selectValueEdit','icNo','newIcNo','brNo','name','accountNo','submitDate'];
		 if(this.telcoMember.selectValueEdit == 'ind'){
		//console.log(this.mandFieldsEdit,'mandFieldsEdit');
		this.mandFieldsEdit.splice(3,1);
		//console.log(this.mandFieldsEdit,'mandFieldsEdit');
		 }
		 else{
		//console.log(this.mandFieldsEdit,'mandFieldsEdit');
		this.mandFieldsEdit.splice(1,2);
		//console.log(this.mandFieldsEdit,'mandFieldsEdit');
		 }
		 if(this.telcoMember.icNo ==""){ 
		 	this.mandFieldsEdit.splice(1,1);
		 	//this.errorHandlerEdit['newIcNo'] = true;
		 	this.errorHandlerEdit['icNo'] = false;
		 	
		 	}else
		if(this.telcoMember.newIcNo ==""){
		this.mandFieldsEdit.splice(2,1);
		//this.errorHandlerEdit['icNo'] = true;
		this.errorHandlerEdit['newIcNo'] = false;
		
		}
		for(let i =0; i<this.mandFieldsEdit.length; i++){
			let item = this.telcoMember[this.mandFieldsEdit[i]];
			//console.log(this.mandFieldsEdit[i],' ', item);
			if(item ==""){
				this.errorHandlerEdit[this.mandFieldsEdit[i]] = true;
				countEdit++;
			} else {
				this.errorHandlerEdit[this.mandFieldsEdit[i]] = false;
			}
			//console.log(this.errorHandler);
			//this.errorHandlerEdit[item] = !this.model[item];
			//console.log(this.errorHandlerEdit[item],'result');
		}
		//console.log(countEdit, 'count');
		if(countEdit <= 1){
		this.mandStatusEdit = false;
		} else {
		this.mandStatusEdit = true;
		}
		//console.log(this.mandFieldsEdit,'mandFieldsEdit');
	}
	reset(){
	this.model = {};
	}
	dateValidate(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		//console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				//console.log(val);
				this.search[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				//console.log(val);
				this.search[field] = val;
			}
			//console.log(val, 'value', this.search[field], field);
		} else {
			e.preventDefault();
		}
	}
	
	dateValidateLeapYear(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.search[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.search[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.search[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.search[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.search[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.search[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.search[field] = "";
						}
					}
				}
			}
		}
	}
	
	dateValidateAdd(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		//console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				//console.log(val);
				this.model[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				//console.log(val);
				this.model[field] = val;
			}
			//console.log(val, 'value', this.model[field], field);
		} else {
			e.preventDefault();
		}
	}
	
	
	dateValidateLeapYearAdd(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.model[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.model[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.model[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.model[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.model[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.model[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.model[field] = "";
						}
					}
				}
			}
		}
	}
	
		dateValidateLeapYearEdit(e, val, field){
		var res = val.split("-");
		if(val.length>'0'&&val.length<'10'){
			this.utils.notify('Invalid Date Format');
			this.telcoMember[field] = "";
		}
		else if(res[0]=='0000'){
			this.utils.notify('Year is Invalid');
			this.telcoMember[field] = "";
		}
		else if(res[1]>'12'||res[1]=='00'){
			this.utils.notify('Month is Invalid');
			this.telcoMember[field] = "";
		}
		else if(res[2]>'31'||res[2]=='00'){
			this.utils.notify('Date is Invalid');
			this.telcoMember[field] = "";
		}
		else if(res[2]<'32'&&res[2]!='00'){
			if(res[1]=='01' || res[1]=='03'|| res[1]=='05' || res[1]=='07' || res[1]=='08' || res[1]=='10' || res[1]=='12'){			
			}
			else{
				if(res[2]=='31'){
					this.utils.notify('Date is Invalid');
					this.telcoMember[field] = "";
				}
				else if(res[1]=='02'){
					if(((res[0] % 4 == 0) && (res[0] % 100 != 0)) || (res[0] % 400 == 0))
					{
						if(res[2]>'29'){
							this.utils.notify('Date is Invalid');
							this.telcoMember[field] = "";
						}						
					}
					else{
						if(res[2]>'28'){
							this.utils.notify('Date is Invalid');
							this.telcoMember[field] = "";
						}
					}
				}
			}
		}
	}
	
	dateValidateEdit(e, val, field){
		if(e.charCode >= 48 && e.charCode <= 57){
		//console.log(val.length);
			if(val.length == 4){
				val= val+'-';
				//console.log(val);
				this.telcoMember[field] = val;
			} else if(val.length == 7){
				val= val+'-';
				//console.log(val);
				this.telcoMember[field] = val;
			}
			//console.log(val, 'value', this.telcoMember[field], field);
		} else {
			e.preventDefault();
		}
	}
  
  

}



// WEBPACK FOOTER //
// ./src/app/telco/telco.component.ts